import React, { Component } from 'react';
import InputValidationError from "../common/InputValidationError";
import Dropzone, {useDropzone} from "react-dropzone";

export default class FilesUpload extends Component {
    constructor(props) {
        super(props);

        this.handleSelectedFileNames = this.handleSelectedFileNames.bind(this);

        this.fileInput = React.createRef();

        this.state = {
            files: [],
            uploadModals: [{id: 0, fileIndex: null}],
        }
    }


    handleSelectedFileNames(file, uploadModal) {
        let inputFiles = Array.from(file);
        let existingFiles = [...this.state.files];
        let files = existingFiles.concat(inputFiles);

        let uploadModals = [...this.state.uploadModals];
        let modalIndex = uploadModals.findIndex(modal => {
            return modal.id === uploadModal.id;
        });
        let modal = {...uploadModals[modalIndex]};

        modal.fileIndex = files.length - 1;
        uploadModals[modalIndex] = modal;

        this.setState({
            files: files,
            uploadModals: uploadModals,
        });

        this.props.updateParentState('files', files);
        this.props.updateParentState('errors', {});
    }

    removeFile(e, uploadModal) {
        e.stopPropagation();
        let files = [...this.state.files];
        files[uploadModal.fileIndex] = null;

        let uploadModals = [...this.state.uploadModals];
        let modalIndex = uploadModals.findIndex(modal => {
           return modal.id === uploadModal.id;
        });

        uploadModals[modalIndex].fileIndex = null;

        this.setState({
            uploadModals: uploadModals,
            files: files,
        });

        this.props.updateParentState('files', files);
    }

    addUploadModal() {
        let modalsArray = [...this.state.uploadModals];

        modalsArray.push({id: modalsArray.length, fileIndex: null});

        this.setState({
            uploadModals: modalsArray
        });
    }

    showRemoveModalButton() {

    }

    render() {
        return (
            <div>
                <div className="row justify-content-center py-1">
                    <div className="col-md-10 text-center">
                        <img src='/assets/img/photo.svg' alt="size" width='200'/>
                    </div>
                </div>
                <div className="row justify-content-center pt-2">
                    <div className="col-md-10">
                        <p className="text-center">Send us a few photos or a video of the waste you need collecting.</p>
                    </div>
                </div>

                <div className="row justify-content-center text-center pt-3">
                    {this.state.uploadModals.map( (uploadModal, index) => {
                        return <div className="col-12 col-md-4" key={index}>
                            <Dropzone onDrop={acceptedFile => this.handleSelectedFileNames(acceptedFile, uploadModal)}
                                      multiple={false}
                                      // accept={'image/jpeg, image/jpg, image/png, '}
                                      key={uploadModal.id}
                            >
                                {({getRootProps, getInputProps}) => (
                                    <div className="quote-upload-modal">
                                        <div {...getRootProps()}>
                                            <input {...getInputProps()} />
                                            {this.state.files[uploadModal.fileIndex] && uploadModal.fileIndex !== null ?
                                              <div className="modal-file-box">
                                                <span className="modal-file-box-remove" onClick={(e) => this.removeFile(e, uploadModal)}>x</span>
                                                <p>{this.state.files[uploadModal.fileIndex].name}</p>
                                              </div>
                                                : <p>Drag and drop some images and videos here, or click to select them</p>
                                            }
                                        </div>
                                    </div>
                                )}
                            </Dropzone>
                        </div>
                    })}
                    <div className="col-12 col-md-4" key={-1}>
                        <div className="quote-upload-modal" onClick={() => this.addUploadModal()}>
                            <p className="mb-0">+ Add new file</p>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}
